import React, { useState, FC } from "react";
import styled  from "styled-components";
import { BORDER_SECONDARY, ORANGE_PRIMARY, TEXT_SECONDARY } from "../../config/Constants";


type tabElementState = {
  tabKey?: string,
  tabName: string,
  tabPath: string,
  selected: boolean,
};

type Props = {
  tabElementStates: tabElementState[];
}

export const RCTab:FC<Props> = (props) => {
    const { tabElementStates } = props;

  return(
    <DivTabWrap>
    {
      tabElementStates.map((tabElementState, index) => (
        <React.Fragment key={index}>
          { tabElementState.selected
             ? <DivTabElementSelected>
                  <SpanLinkTabActive>{tabElementState.tabName}</SpanLinkTabActive>
                </DivTabElementSelected>
              : <DivTabElementNotSelected>
                  <ANotSelected href={tabElementState.tabPath}>{ tabElementState.tabName }</ANotSelected>
                </DivTabElementNotSelected>
          }
        </React.Fragment>
      ))
    }
  </DivTabWrap>
  )
}

const DivTabWrap = styled.div`
  display: flex;
  border-bottom: 1px solid ${BORDER_SECONDARY};
  position: sticky;
  top: 4.5rem;
  background-color: #fff;
  margin: 0 0 0.5rem 0;
  z-index: 102;
`;

const DivTabElementNotSelected = styled.div`
  text-align: center;
  width: 50%;
  color: ${TEXT_SECONDARY};
`;

const DivTabElementSelected = styled.div`
  text-align: center;
  width: 50%;
  border-bottom: 2px solid ${ORANGE_PRIMARY};
  color: ${ORANGE_PRIMARY};
`;

const SpanLinkTabActive = styled.span`
  color: ${ORANGE_PRIMARY};
  text-align: center;
  width: 100%;
  padding: 0.5rem 0;
  display: block;
`;

const ANotSelected = styled.a`
  color: ${TEXT_SECONDARY};
  text-align: center;
  text-decoration: none;
  width: 100%;
  padding: 0.5rem 0;
  display: block;
`;
